import React from 'react';
import { GetStaticProps } from 'next';
import { bffService } from '@thisisdevelopment/akzonobel-core';
import {
  CmsSections,
  CmsSectionType,
  CmsVideo,
  FooterBlocks,
  Page,
} from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { pageRevalidate } from '../../src/config';

type TheHeritageStoryType = {
  title: string;
  headline: string;
  video_cover: number;
  video: number;
  sections: CmsSectionType[];
};

type SSRPageProps = {
  page: TheHeritageStoryType;
};

function TheHeritageStory({ page }: SSRPageProps) {
  const meta = metas.default;
  return (
    <div>
      <NextHead meta={meta} />
      <Page title={page.title} headline={page.headline}>
        <CmsSections sections={page.sections} />
        <CmsVideo coverId={page.video_cover} videoId={page.video} mt="50px" />
        <FooterBlocks page="the-heritage-story" my="40px" />
      </Page>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const page = await bffService.getCmsItem('the_heritage_story').then((res) => res.data.data[0]);
  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export default TheHeritageStory;
